import { useQuery } from "@tanstack/react-query";
import { IPartner } from "../../interfaces/IPartner";
import { customFetcher } from "../useFetch";

export const useGetPartners = () => {
    const {
        data: partnerArray,
        isLoading: isLoadingPartnerArray,
        refetch: refetchPartnerArray,
    } = useQuery<IPartner[]>({
        queryKey: ["partner"],
        queryFn: () => customFetcher({ endpoint: `/partner` }),
    });
    return { partnerArray, isLoadingPartnerArray, refetchPartnerArray };
};
